module.exports = __webpack_public_path__ + "img/bg-left.6b9e4a73.png";